import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { useTheme } from './ThemeContext';
import './theme-toggle.css';

const SunIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="12" cy="12" r="4.1" fill="currentColor" />
    <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
      <path d="M12 2.4v2.3M12 19.3v2.3M2.4 12h2.3M19.3 12h2.3" />
      <path d="M5.1 5.1l1.6 1.6M17.3 17.3l1.6 1.6M18.9 5.1l-1.6 1.6M6.7 17.3l-1.6 1.6" />
    </g>
  </svg>
);

const MoonIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M14.8 3.2a7.7 7.7 0 1 0 6.2 12.2A6.4 6.4 0 0 1 14.8 3.2z"
    />
    <circle cx="18.2" cy="6.1" r="0.9" fill="currentColor" />
  </svg>
);

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const { t } = useLanguage();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      className={`theme-toggle theme-toggle--${theme}`}
      onClick={toggleTheme}
      aria-label={isDark ? t('shell.themeToLight') : t('shell.themeToDark')}
      title={isDark ? t('shell.themeLightTitle') : t('shell.themeDarkTitle')}
    >
      <span className="theme-toggle__glyph">{isDark ? <SunIcon /> : <MoonIcon />}</span>
    </button>
  );
};

export default ThemeToggle;
